import { get, patch, post, upload } from "../utils/api";

export const login = (data) => {
  return post("/auth/login", data);
};
export const register = (data) => {
  return post("/auth/register", data);
};
export const forgot = (data) => {
  return post("/auth/forgot-password", data);
};
export const passwordReset = (data) => {
  return post("/auth/reset-password", data);
};

export const profileDetails = () => {
  return get(`/profile/me`);
};
export const emailVerify = (data) => {
  const token = data?.token
  return get(`/auth/verify-email?token=${token}`);
};

export const updateProfileDetails = (data) => {
  return patch(`/profile/update-info`, data);
};

export const updateAddressMultiple = (data) => {
  return patch(`/address/multiple`, data);
};

export const setDefaultAddress = (id) => {
  return patch(`/address/default/${id}`);
};
export const setVirtualAddress = () => {
  return get(`/virtual-locker`);
};
export const virtualAccept = () => {
  return post(`/virtual-locker`);
};
export const uploadImage = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return upload(`/upload/file`, formData);
};

export const authApi = {
  login,
  register,
  forgot,
  passwordReset,
  profileDetails,
  updateProfileDetails,
  updateAddressMultiple,
  setDefaultAddress,
  setVirtualAddress,
  virtualAccept,
  emailVerify,
  uploadImage
};
